import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  loginInitStateReducerType,
  loginSetHasInstitutionLoginReducerType,
  loginSetHasRegistrationReducerType,
  loginSetIpAddressReducerType,
  loginSetIsFormDisabledReducerType,
  loginSetIsLoadingReducerType,
  loginSetLoginFailReducerType,
  loginSetNotificationsReducerType,
  loginSetOccurrenceDateReducerType,
  loginSetTimestampReducerType,
  loginSetDataReducerType,
} from './LoginConstants';

export const initialState = Map({
  data: {
    username: '',
    password: '',
    remember_me: true,
  },
  ipAddress: null,
  isFormDisabled: false,
  isLoading: false,
  loginFail: null,
  hasRegistration: false,
  hasInstitutionLogin: false,
  notifications: null,
  occurrenceDate: null,
});

const spec = {
  [loginInitStateReducerType]: (state, action) => {
    const { updatedInitialState } = action.payload;
    return initialState.merge(Map(updatedInitialState));
  },
  [loginSetIpAddressReducerType]: (state, action) => {
    const { ipAddress } = action.payload;
    return state.set('ipAddress', ipAddress);
  },
  [loginSetIsFormDisabledReducerType]: (state, action) => {
    const { isFormDisabled } = action.payload;
    return state.set('isFormDisabled', isFormDisabled);
  },
  [loginSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [loginSetLoginFailReducerType]: (state, action) => {
    const { loginFail } = action.payload;
    return state.set('loginFail', loginFail);
  },
  [loginSetHasRegistrationReducerType]: (state, action) => {
    const { hasRegistration } = action.payload;
    return state.set('hasRegistration', hasRegistration);
  },
  [loginSetHasInstitutionLoginReducerType]: (state, action) => {
    const { hasInstitutionLogin } = action.payload;
    return state.set('hasInstitutionLogin', hasInstitutionLogin);
  },
  [loginSetNotificationsReducerType]: (state, action) => {
    const { notifications } = action.payload;
    return state.set('notifications', notifications);
  },
  [loginSetOccurrenceDateReducerType]: (state, action) => {
    const { occurrenceDate } = action.payload;
    return state.set('occurrenceDate', occurrenceDate);
  },
  [loginSetTimestampReducerType]: (state, action) => {
    const { timestamp } = action.payload;
    return state.set('timestamp', timestamp);
  },
  [loginSetDataReducerType]: (state, action) => state.update('data', (data) => ({ ...data, ...action.payload })),
};

export default createReducerBySpec(spec, initialState);
